import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import facebookLogo from 'assets/facebook-logo.png';
import { useAuthSelector, useAuthService } from '../containers/Auth';
import { SCOPES } from '~/api/routes/auth/user';

const getSize = (size) => {
  switch (size) {
    case 'lg':
      return 16;
    case 'sm':
    default:
      return 10;
  }
};

const Button = styled.button<{ size?: 'lg' | 'sm' }>`
  background-color: #0075fb;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  font-weight: bold;
  cursor: pointer;

  &:active {
    opacity: 80%;
  }

  ${(props) => {
    const size = getSize(props.size);

    return css`
      font-size: ${size}px;
      padding: ${size / 2}px;
      border-radius: ${size}px;
    `;
  }}
`;

const Logo = styled.img<{ size?: 'lg' | 'sm' }>`
  ${(props) => {
    const size = getSize(props.size) * 1.2;
    return css`
      width: ${size}px;
      height: ${size}px;
      margin-right: ${size / 4}px;
    `;
  }}
`;

interface Props {
  size?: 'lg' | 'sm';
}

function FacebookButton(props: Props) {
  const { size } = props;

  const { send: sendAuthService } = useAuthService();

  const isLoggedOut = useAuthSelector(state => state.matches('loggedOutFB'));

  const handleClick = React.useCallback(() => {
    // NOTE: this is absolutely a hack to fix:
    // https://sentry.io/organizations/realgeeks/issues/2994102652

    // I have no idea why fb thinks we didn't already call init with a valid version,
    // because we did, but we'll do it again to make them happy i guess
    FB.init({
      appId: '1654788274772389',
      cookie: true,
      version: 'v19.0',
    });
    if (isLoggedOut) {
      FB.login(
        (response) => {
          if (response.status === 'connected') {
            sendAuthService({ type: 'FB.authorized', authResponse: response.authResponse });
          }
        },
        {
          scope: SCOPES.join(),
          return_scopes: true,
        },
      );
    } else {
      FB.logout(() => {
        sendAuthService('FB.logout');
      });
    }
  }, [isLoggedOut, sendAuthService]);

  return (
    <Button type="button" onClick={handleClick} size={size}>
      <Logo src={facebookLogo} size={size} />
      {isLoggedOut ? 'Login to Facebook' : 'Log Out'}
    </Button>
  );
}

export default FacebookButton;
